import { applyAudioSettings } from '../audio/engine';
import { el } from './dom';
import { loadSettings, saveSettings } from './settings';

/** Settings dialog, reachable from the title screen (and, once audio lands,
 * from an in-game gear button — this export is that hook). Every change
 * persists immediately; there is no Save button to forget. */
export function showSettingsModal(root: HTMLElement): void {
  const settings = loadSettings();

  const volume = el('input', { class: 'settings-slider', type: 'range' }) as HTMLInputElement;
  volume.min = '0';
  volume.max = '100';
  volume.value = String(Math.round(settings.musicVolume * 100));
  volume.addEventListener('input', () => {
    settings.musicVolume = Number(volume.value) / 100;
    saveSettings(settings);
    applyAudioSettings(settings);
  });

  const toggle = (label: string, key: 'musicOn' | 'sfxOn'): HTMLElement => {
    const button = el('button', { class: 'mini wide' }, settings[key] ? 'ON' : 'off');
    button.onclick = () => {
      settings[key] = !settings[key];
      button.textContent = settings[key] ? 'ON' : 'off';
      saveSettings(settings);
      applyAudioSettings(settings);
    };
    return el('div', { class: 'settings-row' }, el('span', {}, label), button);
  };

  const backdrop = el(
    'div',
    { class: 'modal-backdrop' },
    el(
      'div',
      { class: 'panel modal' },
      el('div', { class: 'modal-title' }, 'Settings'),
      el('div', { class: 'settings-row' }, el('span', {}, 'Music volume'), volume),
      toggle('Music', 'musicOn'),
      toggle('Sound effects', 'sfxOn'),
      el('button', { class: 'modal-close', onclick: () => backdrop.remove() }, 'Done'),
    ),
  );
  backdrop.addEventListener('click', (event) => {
    if (event.target === backdrop) backdrop.remove();
  });
  root.append(backdrop);
}
